// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_58-0";
export var eligibilityCardNotEligible = "_58-1";